/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/**

## Card Header

The `sq-card/header` component is designed to be used as a contextual component in: [sq-card](/components/glass/sq-card.html).

### Parameters
@param {String} [title] - The title of the card. Alternatively, it can be passed into the yielded `title` component.
@param {String} titleSecondary - Text to appear to the right of the title
@param {String} link.text - Text for the link.
@param {String} link.href - URL for the link. Alternative to `action` and `component.`
@param {Action} link.action - Action to trigger on link click. Alternative to `href` and `component.`
@param {Component} link.component - The (link-to) component to handle the link. Alternative to `href` and `action.`

**/

import { isPresent } from '@ember/utils';
import { assert } from '@ember/debug';
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['card__header'],
  title: null,
  titleSecondary: null,
  link: null,
  didReceiveAttrs() {
    this._super();
    const isLinkTextPresent = isPresent(this.get('link.text'));
    const isLinkHrefPresent = isPresent(this.get('link.href'));
    const isLinkActionPresent = isPresent(this.get('link.action'));
    const isLinkComponentPresent = isPresent(this.get('link.component'));
    assert('Only pass one or none of `link.href`, `link.action`, `link.component` to `{{card/header}}`', isLinkHrefPresent + isLinkActionPresent + isLinkComponentPresent <= 1);
    if (isLinkHrefPresent || isLinkActionPresent || isLinkComponentPresent) {
      assert('`link.text` must be passed when using `link.href`, `link.action`, or `link.component` in `{{card/header}}`', isLinkTextPresent);
    }
  }
});